import { CALL_API } from '../../api';
import * as ActionTypes from './region.actionTypes';
import schema from '../../api/schema';

export const invalidateRegion = (id) => (dispatch, getState) => {
  dispatch({
    type: ActionTypes.INVALIDATE_REGION,
    payload: {
      id
    }
  });

  return dispatch(readRegion(id));
};

const readRegions = () => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_REGIONS_REQUEST,
      ActionTypes.READ_REGIONS_SUCCESS,
      ActionTypes.READ_REGIONS_FAILURE,
    ],
    endpoint: 'api/region/',
    schema: schema.regionsSchema,
    authorization: true,
  }
});

export const getRegions = () => (dispatch, getState) => {
  return dispatch(readRegions());
};

const readRegionsByChannel = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_REGIONS_REQUEST,
      ActionTypes.READ_REGIONS_SUCCESS,
      ActionTypes.READ_REGIONS_FAILURE,
    ],
    endpoint: `api/region/all/${id}`,
    schema: schema.regionsSchema,
    authorization: true,
  }
});

export const getRegionsByChannel = (id) => (dispatch, getState) => {
  return dispatch(readRegionsByChannel(id));
};

const readRegion = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_REGION_REQUEST,
      ActionTypes.READ_REGION_SUCCESS,
      ActionTypes.READ_REGION_FAILURE,
    ],
    endpoint: `api/region/${id}`,
    schema: schema.regionSchema,
    authorization: true,
  },
  payload: {
    id
  }
});

export const getRegion = (id) => (dispatch, getState) => {
  return dispatch(readRegion(id));
};

const doCreateRegion = (data) => ({
  [CALL_API]: {
    types: [
      ActionTypes.CREATE_REGION_REQUEST,
      ActionTypes.CREATE_REGION_SUCCESS,
      ActionTypes.CREATE_REGION_FAILURE,
    ],
    endpoint: 'api/region/',
    schema: schema.regionSchema,
    authorization: true,
    requestInit: {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data)
    },
  }
});

export const createRegion = (data) => (dispatch, getState) => {
  return dispatch(doCreateRegion(data));
};

const doUpdateRegion = (data) => ({
  [CALL_API]: {
    types: [
      ActionTypes.UPDATE_REGION_REQUEST,
      ActionTypes.UPDATE_REGION_SUCCESS,
      ActionTypes.UPDATE_REGION_FAILURE,
    ],
    endpoint: `api/region/${data._id}`,
    schema: schema.regionSchema,
    authorization: true,
    requestInit: {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data)
    },
  },
  payload: {
    id: data._id
  }
});

export const updateRegion = (data) => (dispatch, getState) => {
  return dispatch(doUpdateRegion(data));
};

const doDeleteRegion = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.DELETE_REGION_REQUEST,
      ActionTypes.DELETE_REGION_SUCCESS,
      ActionTypes.DELETE_REGION_FAILURE,
    ],
    endpoint: `api/region/${id}`,
    schema: schema.regionSchema,
    authorization: true,
    requestInit: {
      method: 'DELETE',
    },
  },
  payload: {
    id
  }
});

export const deleteRegion = (id) => (dispatch, getState) => {
  return dispatch(doDeleteRegion(id));
};


// WEBPACK FOOTER //
// ./src/modules/region/region.actions.js